webpackJsonp([4],{

/***/ 1096:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryDraftAdd_vue__ = __webpack_require__(1228);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eaf0607_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryDraftAdd_vue__ = __webpack_require__(1293);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryDraftAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eaf0607_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryDraftAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FTextarea',
  components: {
    FGroup: __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__["a" /* default */]
  },
  props: {
    value: {
      default: ''
    },
    label: String,
    id: {
      type: String,
      required: true
    },
    rows: {
      default: 3
    },
    required: Boolean,
    placeholder: String,
    tooltip: String,
    error: {
      type: String,
      default: null
    }
  }
});

/***/ }),

/***/ 1133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FTextarea_vue__ = __webpack_require__(1128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dfa61c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FTextarea_vue__ = __webpack_require__(1134);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dfa61c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-group',{attrs:{"label":_vm.label,"id":_vm.id,"required":_vm.required,"tooltip":_vm.tooltip,"error":_vm.error}},[_c('textarea',{class:['form-control', _vm.error && 'is-invalid'],attrs:{"id":_vm.id,"rows":_vm.rows,"required":_vm.required,"placeholder":_vm.placeholder,"autocomplete":"off"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppButton__ = __webpack_require__(92);
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MobileSubmitButton',
  components: {
    AppButton: __WEBPACK_IMPORTED_MODULE_0__components_AppButton__["a" /* default */]
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    noBottom: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 1147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useScrollToError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);

function useScrollToError(errors) {
  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(errors, function () {
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["f" /* nextTick */])(function () {
      var first = document.querySelector('.is-invalid');

      if (first) {
        first.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    });
  });
}

/***/ }),

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileSubmitButton_vue__ = __webpack_require__(1137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6370764f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileSubmitButton_vue__ = __webpack_require__(1149);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileSubmitButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6370764f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileSubmitButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['d-lg-none mt-3', _vm.noBottom ? '' : 'mb-4']},[_c('app-button',{attrs:{"type":"submit","loading":_vm.loading}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FText__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FCheckbox__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormFields_FTextarea__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormFields_FSearchSelect__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Drafts_CommitteeSecretaryPicker__ = __webpack_require__(1196);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // "YYYY-MM-DDTHH:mm" (datetime-local) → same format, shifted +24h

function plus24Hours(val) {
  var d = new Date(val);
  if (Number.isNaN(d.getTime())) return '';
  d.setHours(d.getHours() + 24);

  var pad = function pad(n) {
    return String(n).padStart(2, '0');
  };

  return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()), "T").concat(pad(d.getHours()), ":").concat(pad(d.getMinutes()));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DraftDetailsSection',
  components: {
    FText: __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FText__["a" /* default */],
    FCheckbox: __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FCheckbox__["a" /* default */],
    FTextarea: __WEBPACK_IMPORTED_MODULE_2__components_FormFields_FTextarea__["a" /* default */],
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_3__components_FormFields_FSearchSelect__["a" /* default */],
    CommitteeSecretaryPicker: __WEBPACK_IMPORTED_MODULE_4__components_Drafts_CommitteeSecretaryPicker__["a" /* default */]
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    edit: Boolean,
    availableDrafts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loadingDrafts: {
      type: Boolean,
      default: false
    },
    states: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loadingStates: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    e: function e(field) {
      return this.errors[field] ? this.errors[field][0] : null;
    },
    draftOptionLabel: function draftOptionLabel(draft) {
      return draft.start_date ? "".concat(draft.start_date, " ").concat(draft.name) : draft.name;
    },
    update: function update(field, val) {
      // Monolith parity: picking Noms Open defaults Noms Closed to open + 24h.
      if (field === 'noms_open' && val) {
        this.$emit('input', _objectSpread({}, this.value, {
          noms_open: val,
          noms_closed: plus24Hours(val)
        }));
        return;
      }

      this.$emit('input', _objectSpread({}, this.value, _defineProperty({}, field, val)));
    },
    pickSecretary: function pickSecretary(secretary) {
      this.$emit('input', _objectSpread({}, this.value, {
        secretary_contact_name: secretary.name,
        secretary_phone_number: secretary.phone
      }));
    },
    onDraftSelect: function onDraftSelect(draft) {
      if (!draft) return;
      this.$emit('input', _objectSpread({}, this.value, {
        name: draft.name,
        draft_id: draft.id,
        start_date: draft.start_date || this.value.start_date,
        finish_date: draft.end_date || this.value.finish_date,
        is_national_finals: draft.is_national_finals != null ? draft.is_national_finals : this.value.is_national_finals,
        event_members_allowed: draft.event_members_allowed != null ? draft.event_members_allowed : this.value.event_members_allowed
      }));
    }
  }
});

/***/ }),

/***/ 1163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_committees__ = __webpack_require__(93);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Draft Setup helper: the secretary contact is not always the person filling the form, so a
// secretary of the committee (own, or the one a Super Secretary is acting for) can be picked
// from a popup. Emits `select` with { name, phone }.

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeSecretaryPicker',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
  },
  data: function data() {
    return {
      showModal: false,
      loading: false,
      error: '',
      secretaries: []
    };
  },
  methods: {
    open: function open() {
      var _this = this;

      this.showModal = true;
      this.loading = true;
      this.error = '';
      __WEBPACK_IMPORTED_MODULE_1__services_api_committees__["a" /* default */].getSecretaries().then(function (response) {
        _this.secretaries = response.data.data;
      }).catch(function () {
        _this.error = 'Unable to load secretaries. Please try again.';
      }).finally(function () {
        _this.loading = false;
      });
    },
    select: function select(secretary) {
      this.$emit('select', {
        name: secretary.name,
        phone: secretary.phone || ''
      });
      this.showModal = false;
    }
  }
});

/***/ }),

/***/ 1164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FText__ = __webpack_require__(146);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DraftRulesSection',
  components: {
    FText: __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FText__["a" /* default */]
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    e: function e(field) {
      return this.errors[field] ? this.errors[field][0] : null;
    },
    update: function update(field, val) {
      this.$emit('input', _objectSpread({}, this.value, _defineProperty({}, field, val)));
    }
  }
});

/***/ }),

/***/ 1165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FText__ = __webpack_require__(146);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MedicalServicesSection',
  components: {
    FText: __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FText__["a" /* default */]
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    e: function e(field) {
      return this.errors[field] ? this.errors[field][0] : null;
    },
    update: function update(field, val) {
      this.$emit('input', _objectSpread({}, this.value, _defineProperty({}, field, val)));
    }
  }
});

/***/ }),

/***/ 1166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FText__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FCheckbox__ = __webpack_require__(145);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentDetailsSection',
  components: {
    FText: __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FText__["a" /* default */],
    FCheckbox: __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FCheckbox__["a" /* default */]
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    isStripeVerified: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    e: function e(field) {
      return this.errors[field] ? this.errors[field][0] : null;
    },
    update: function update(field, val) {
      this.$emit('input', _objectSpread({}, this.value, _defineProperty({}, field, val)));
    }
  }
});

/***/ }),

/***/ 1191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDraftStates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__ = __webpack_require__(74);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useDraftStates() {
  var states = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function fetch() {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].states();

            case 4:
              res = _context.sent;
              states.value = res.data.data;

            case 6:
              _context.prev = 6;
              loading.value = false;
              return _context.finish(6);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 6, 9]]);
    }));
    return _fetch.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(fetch);
  return {
    states: states,
    loading: loading
  };
}

/***/ }),

/***/ 1192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultDraftForm; });
/* harmony export (immutable) */ __webpack_exports__["a"] = useDraftForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composables_useScrollToError__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_EventBus__ = __webpack_require__(18);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





var defaultDraftForm = function defaultDraftForm() {
  return {
    name: '',
    draft_id: null,
    noms_open: '',
    noms_closed: '',
    start_date: '',
    finish_date: '',
    draft_state_id: null,
    interval_num: 50,
    secretary_contact_name: '',
    secretary_phone_number: '',
    is_final: false,
    stock_levy: '20.00',
    draft_notes: '',
    event_members_allowed: false,
    is_show_biosecurity_form: false,
    required_vehicles: false,
    first_round_runs_per_person: '',
    total_runs_per_horse: '',
    provider_name: '',
    provider_contact_name: '',
    provider_phone: '',
    payments_due: '',
    online_payments_only: false,
    additional_attachment_1: null,
    additional_attachment_2: null,
    additional_attachment_1_url: null,
    additional_attachment_2_url: null,
    program: null,
    secretary_program: null,
    temporary_program: null,
    program_file: null,
    program_color: '#8c2535'
  };
};

function toDatetimeLocal(str) {
  if (!str) return '';
  return str.replace(' ', 'T').substring(0, 16);
}

function toDateOnly(str) {
  if (!str) return '';
  return str.substring(0, 10);
}

function mapDraftToForm(draft) {
  var s = draft.settings != null ? draft.settings : {};
  return {
    name: draft.name || '',
    noms_open: toDatetimeLocal(draft.noms_open),
    noms_closed: toDatetimeLocal(draft.noms_closed),
    start_date: draft.start_date || '',
    finish_date: draft.end_date || '',
    draft_state_id: draft.state_id != null ? draft.state_id : null,
    is_final: !!draft.is_final,
    program: draft.program != null ? draft.program : null,
    secretary_program: draft.secretary_program != null ? draft.secretary_program : null,
    temporary_program: s.temporary_program != null ? s.temporary_program : null,
    interval_num: s.interval_num != null ? s.interval_num : 50,
    secretary_contact_name: s.secretary_contact_name || '',
    secretary_phone_number: s.secretary_phone_number || '',
    stock_levy: s.stock_levy || '20.00',
    draft_notes: s.draft_notes || '',
    event_members_allowed: !!s.event_members_allowed,
    is_show_biosecurity_form: !!s.is_show_biosecurity_form,
    required_vehicles: !!s.required_vehicles,
    first_round_runs_per_person: s.first_round_runs_per_person != null ? s.first_round_runs_per_person : '',
    total_runs_per_horse: s.total_runs_per_horse != null ? s.total_runs_per_horse : '',
    provider_name: s.provider_name || '',
    provider_contact_name: s.provider_contact_name || '',
    provider_phone: s.provider_phone || '',
    payments_due: toDateOnly(s.payments_due),
    online_payments_only: !!s.online_payments_only,
    additional_attachment_1: null,
    additional_attachment_2: null,
    additional_attachment_1_url: s.additional_attachment_1 != null ? s.additional_attachment_1 : null,
    additional_attachment_2_url: s.additional_attachment_2 != null ? s.additional_attachment_2 : null,
    program_color: s.program_color != null ? s.program_color : '#8c2535'
  };
}

function useDraftForm(form) {
  var errors = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});
  Object(__WEBPACK_IMPORTED_MODULE_2__composables_useScrollToError__["a" /* default */])(errors);
  var submitting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var submitted = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var loadFailed = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var isStripeVerified = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function loadDraft(_x) {
    return _loadDraft.apply(this, arguments);
  }

  function _loadDraft() {
    _loadDraft = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(id) {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              loadFailed.value = false;
              _context.prev = 2;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].forEdit(id);

            case 5:
              res = _context.sent;
              Object.assign(form, mapDraftToForm(res.data.data));
              isStripeVerified.value = !!res.data.data.is_stripe_verified;
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              loadFailed.value = true;
              __WEBPACK_IMPORTED_MODULE_3__store_EventBus__["a" /* default */].$emit('http-error-persistent', 'Draft not found or you do not have access to it.');

            case 14:
              _context.prev = 14;
              loading.value = false;
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10, 14, 17]]);
    }));
    return _loadDraft.apply(this, arguments);
  }

  function reloadDraft(_x2) {
    return _reloadDraft.apply(this, arguments);
  }

  function _reloadDraft() {
    _reloadDraft = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(id) {
      var res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].forEdit(id);

            case 3:
              res = _context2.sent;
              Object.assign(form, mapDraftToForm(res.data.data));
              isStripeVerified.value = !!res.data.data.is_stripe_verified;
              _context2.next = 10;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));
    return _reloadDraft.apply(this, arguments);
  }

  function submit() {
    return _submit.apply(this, arguments);
  }

  function _submit() {
    _submit = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      var res, id, data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              submitting.value = true;
              errors.value = {};
              _context3.prev = 2;
              _context3.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].setup(_objectSpread({}, form));

            case 5:
              res = _context3.sent;
              submitted.value = true;
              id = res.data.data != null ? res.data.data.id : null;
              return _context3.abrupt("return", {
                message: res.data.message != null ? res.data.message : true,
                id: id
              });

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](2);
              data = _context3.t0.response != null ? _context3.t0.response.data : null;

              if (data != null && data.code === 'validation_error') {
                errors.value = data.errors;
              }

              return _context3.abrupt("return", false);

            case 16:
              _context3.prev = 16;
              submitting.value = false;
              return _context3.finish(16);

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 11, 16, 19]]);
    }));
    return _submit.apply(this, arguments);
  }

  function buildPayload(f) {
    return {
      name: f.name,
      noms_open: f.noms_open ? "".concat(f.noms_open.replace('T', ' '), ":00") : null,
      noms_closed: f.noms_closed ? "".concat(f.noms_closed.replace('T', ' '), ":00") : null,
      start_date: f.start_date || null,
      finish_date: f.finish_date || null,
      draft_state_id: f.draft_state_id,
      is_final: f.is_final,
      secretary_contact_name: f.secretary_contact_name,
      secretary_phone_number: f.secretary_phone_number,
      provider_name: f.provider_name,
      provider_contact_name: f.provider_contact_name,
      provider_phone: f.provider_phone,
      interval_num: f.interval_num,
      first_round_runs_per_person: f.first_round_runs_per_person !== '' ? f.first_round_runs_per_person : null,
      total_runs_per_horse: f.total_runs_per_horse !== '' ? f.total_runs_per_horse : null,
      stock_levy: f.stock_levy,
      payments_due: f.payments_due ? "".concat(f.payments_due, " 00:00:00") : null,
      online_payments_only: f.online_payments_only,
      event_members_allowed: f.event_members_allowed,
      is_show_biosecurity_form: f.is_show_biosecurity_form,
      required_vehicles: f.required_vehicles,
      draft_notes: f.draft_notes || null
    };
  }

  function updateDraft(_x3) {
    return _updateDraft.apply(this, arguments);
  }

  function _updateDraft() {
    _updateDraft = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(id) {
      var res, data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              submitting.value = true;
              errors.value = {};
              _context4.prev = 2;
              _context4.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].update(id, buildPayload(form));

            case 5:
              res = _context4.sent;
              return _context4.abrupt("return", res.data.message != null ? res.data.message : true);

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](2);
              data = _context4.t0.response != null ? _context4.t0.response.data : null;

              if (data != null && data.code === 'validation_error') {
                errors.value = data.errors;
              }

              return _context4.abrupt("return", false);

            case 14:
              _context4.prev = 14;
              submitting.value = false;
              return _context4.finish(14);

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 9, 14, 17]]);
    }));
    return _updateDraft.apply(this, arguments);
  }

  return {
    errors: errors,
    submitting: submitting,
    submitted: submitted,
    submit: submit,
    updateDraft: updateDraft,
    loading: loading,
    loadFailed: loadFailed,
    isStripeVerified: isStripeVerified,
    loadDraft: loadDraft,
    reloadDraft: reloadDraft
  };
}

/***/ }),

/***/ 1193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftDetailsSection_vue__ = __webpack_require__(1162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_365c5540_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftDetailsSection_vue__ = __webpack_require__(1198);
function injectStyle (ssrContext) {
  __webpack_require__(1194)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-365c5540"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftDetailsSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_365c5540_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftDetailsSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1194:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1195);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("3adc3cd7", content, true, {});

/***/ }),

/***/ 1195:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".secretary-picker-row[data-v-365c5540]{margin-top:-1rem}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Drafts/DraftDetailsSection.vue"],"names":[],"mappings":"AA2PA,uCACE,gBAAkB,CACnB","file":"DraftDetailsSection.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Sits right under the Secretary Contact fields instead of a full grid row-gap below them */\n.secretary-picker-row[data-v-365c5540] {\n  margin-top: -1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeSecretaryPicker_vue__ = __webpack_require__(1163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340c94ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeSecretaryPicker_vue__ = __webpack_require__(1197);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeSecretaryPicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340c94ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeSecretaryPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"committee-secretary-picker"},[_c('span',{staticClass:"text-muted"},[_vm._v("Pick the contact from the committee ")]),_vm._v(" "),_c('a',{staticClass:"text-primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.open($event)}}},[_vm._v("secretaries")]),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('h2',{staticClass:"h4 mb-0",attrs:{"slot":"header"},slot:"header"},[_vm._v("Committee Secretaries")]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"body"},slot:"body"},[(_vm.loading)?_c('div',{staticClass:"text-center p-3"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):(_vm.error)?_c('div',{staticClass:"alert alert-warning mb-0"},[_vm._v(_vm._s(_vm.error))]):(_vm.secretaries.length === 0)?_c('p',{staticClass:"text-center text-muted mb-0"},[_vm._v("No secretaries found.")]):_c('div',{staticClass:"list-group"},_vm._l((_vm.secretaries),function(secretary){return _c('button',{key:secretary.id,staticClass:"list-group-item list-group-item-action d-flex justify-content-between align-items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.select(secretary)}}},[_c('span',[_vm._v(_vm._s(secretary.name))]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(secretary.phone))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center",attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.showModal = false}}},[_vm._v("Cancel")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',{staticClass:"h3 mb-3"},[_vm._v("Draft Details")]),_vm._v(" "),_c('div',{staticClass:"f-form"},[_c('div',{staticClass:"f-form__half"},[(_vm.edit)?_c('f-text',{attrs:{"id":"draftName","label":"Draft Name","value":_vm.value.name,"required":"","error":_vm.e('name')},on:{"input":function($event){return _vm.update('name', $event)}}}):_c('f-search-select',{attrs:{"id":"draftName","label":"Draft Name","value":_vm.value.draft_id,"options":_vm.availableDrafts,"track-by":"id","custom-label":_vm.draftOptionLabel,"placeholder":"Select draft","loading":_vm.loadingDrafts,"required":"","error":_vm.e('draft_id')},on:{"input":function($event){return _vm.update('draft_id', $event)},"select":_vm.onDraftSelect}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-text',{attrs:{"id":"nomsOpen","label":"Noms Open","type":"datetime-local","value":_vm.value.noms_open,"required":"","error":_vm.e('noms_open')},on:{"input":function($event){return _vm.update('noms_open', $event)}}}),_vm._v(" "),_c('f-text',{attrs:{"id":"nomsClosed","label":"Noms Closed","type":"datetime-local","value":_vm.value.noms_closed,"error":_vm.e('noms_closed')},on:{"input":function($event){return _vm.update('noms_closed', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-text',{attrs:{"id":"startDate","label":"Start Date","type":"date","value":_vm.value.start_date,"required":"","error":_vm.e('start_date')},on:{"input":function($event){return _vm.update('start_date', $event)}}}),_vm._v(" "),_c('f-text',{attrs:{"id":"finishDate","label":"Finish Date","type":"date","value":_vm.value.finish_date,"required":"","error":_vm.e('finish_date')},on:{"input":function($event){return _vm.update('finish_date', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-search-select',{attrs:{"id":"status","label":"Status","value":_vm.value.draft_state_id,"options":_vm.states,"option-tooltip":function (state) { return state.description || ''; },"loading":_vm.loadingStates,"searchable":false,"required":"","error":_vm.e('draft_state_id')},on:{"input":function($event){return _vm.update('draft_state_id', $event)}}}),_vm._v(" "),_c('f-text',{attrs:{"id":"intervalNum","label":"Spacings","type":"number","value":_vm.value.interval_num,"placeholder":"50","error":_vm.e('interval_num')},on:{"input":function($event){return _vm.update('interval_num', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-text',{attrs:{"id":"secretaryContactName","label":"Secretary Contact Name","value":_vm.value.secretary_contact_name,"required":"","error":_vm.e('secretary_contact_name')},on:{"input":function($event){return _vm.update('secretary_contact_name', $event)}}}),_vm._v(" "),_c('f-text',{attrs:{"id":"secretaryPhoneNumber","label":"Secretary Phone Number","value":_vm.value.secretary_phone_number,"required":"","error":_vm.e('secretary_phone_number')},on:{"input":function($event){return _vm.update('secretary_phone_number', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__full secretary-picker-row"},[_c('committee-secretary-picker',{on:{"select":_vm.pickSecretary}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__half"},[_c('f-checkbox',{attrs:{"id":"isFinal","label":"National Finals","value":_vm.value.is_final},on:{"input":function($event){return _vm.update('is_final', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-text',{attrs:{"id":"stockLevy","label":"Stock Levy","value":_vm.value.stock_levy,"placeholder":"20.00"},on:{"input":function($event){return _vm.update('stock_levy', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__half f-form__half--lg"},[_c('f-textarea',{attrs:{"id":"draftNotes","label":"Draft Notes","value":_vm.value.draft_notes,"rows":3},on:{"input":function($event){return _vm.update('draft_notes', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-checkbox',{attrs:{"id":"eventMembersAllowed","label":"Allow event members to participate","value":_vm.value.event_members_allowed,"lock-if-true":true,"hint":"Once this option is selected and saved, it cannot be undone."},on:{"input":function($event){return _vm.update('event_members_allowed', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__half"},[_c('f-checkbox',{attrs:{"id":"isShowBiosecurityForm","label":"Add a Biosecurity Form to the Draft","value":_vm.value.is_show_biosecurity_form},on:{"input":function($event){return _vm.update('is_show_biosecurity_form', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-checkbox',{attrs:{"id":"requiredVehicles","label":"Make competitor vehicle mandatory","value":_vm.value.required_vehicles},on:{"input":function($event){return _vm.update('required_vehicles', $event)}}}),_vm._v(" "),_c('div')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftRulesSection_vue__ = __webpack_require__(1164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d9f66e9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftRulesSection_vue__ = __webpack_require__(1200);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftRulesSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d9f66e9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftRulesSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',{staticClass:"h3 mb-3  mt-5"},[_vm._v("Draft Rules")]),_vm._v(" "),_c('div',{staticClass:"f-form"},[_c('div',{staticClass:"f-form__half"},[_c('f-text',{attrs:{"id":"firstRoundRunsPerPerson","label":"First Round Runs Per Person","type":"number","value":_vm.value.first_round_runs_per_person,"hint":"Leave blank or 0 if unlimited","error":_vm.e('first_round_runs_per_person')},on:{"input":function($event){return _vm.update('first_round_runs_per_person', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__half"},[_c('f-text',{attrs:{"id":"totalRunsPerHorse","label":"Total Runs Per Horse","type":"number","value":_vm.value.total_runs_per_horse,"hint":"Leave blank or 0 if unlimited","error":_vm.e('total_runs_per_horse')},on:{"input":function($event){return _vm.update('total_runs_per_horse', $event)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicalServicesSection_vue__ = __webpack_require__(1165);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66dfaa35_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MedicalServicesSection_vue__ = __webpack_require__(1202);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicalServicesSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66dfaa35_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MedicalServicesSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',{staticClass:"h3 mb-3 mt-5"},[_vm._v("Medical Services")]),_vm._v(" "),_c('div',{staticClass:"f-form"},[_c('div',{staticClass:"f-form__third"},[_c('f-text',{attrs:{"id":"providerName","label":"Provider Name","value":_vm.value.provider_name,"error":_vm.e('provider_name')},on:{"input":function($event){return _vm.update('provider_name', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__third"},[_c('f-text',{attrs:{"id":"providerContactName","label":"Provider Contact Name","value":_vm.value.provider_contact_name,"error":_vm.e('provider_contact_name')},on:{"input":function($event){return _vm.update('provider_contact_name', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__third"},[_c('f-text',{attrs:{"id":"providerPhone","label":"Provider Phone","value":_vm.value.provider_phone,"error":_vm.e('provider_phone')},on:{"input":function($event){return _vm.update('provider_phone', $event)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentDetailsSection_vue__ = __webpack_require__(1166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b8aa72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentDetailsSection_vue__ = __webpack_require__(1204);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentDetailsSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b8aa72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentDetailsSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',{staticClass:"h3 mb-3 mt-5"},[_vm._v("Payment Details")]),_vm._v(" "),_c('div',{staticClass:"f-form"},[_c('div',{staticClass:"f-form__half f-form__half--solo"},[_c('f-text',{attrs:{"id":"paymentsDue","label":"Payments Due","type":"date","value":_vm.value.payments_due,"hint":"NOTE: Email reminders for unpaid invoices will be sent at 12PM (AEST) the day before payments are due.","error":_vm.e('payments_due')},on:{"input":function($event){return _vm.update('payments_due', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__half f-form__half--solo"},[_c('f-checkbox',{attrs:{"id":"onlinePaymentsOnly","label":"Card Payments Only","value":_vm.value.online_payments_only,"disabled":!_vm.isStripeVerified},on:{"input":function($event){return _vm.update('online_payments_only', $event)}}}),_vm._v(" "),(!_vm.isStripeVerified)?_c('small',{staticClass:"form-text text-muted mt-1"},[_vm._v("\n        The feature to accept online payments exclusively will be available after Stripe verifies the committee account.\n      ")]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SecretaryDraftDetails__ = __webpack_require__(1288);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'SecretaryDraftAdd',
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    'secretary-draft-details': __WEBPACK_IMPORTED_MODULE_2__SecretaryDraftDetails__["a" /* default */]
  },
  setup: function setup() {
    return {};
  }
}));

/***/ }),

/***/ 1229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composables_drafts_useAvailableDrafts__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__composables_drafts_useDraftStates__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__composables_drafts_useDraftForm__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__composables_useCurrentUser__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_MobileSubmitButton__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Drafts_DraftDetailsSection__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Drafts_DraftRulesSection__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Drafts_MedicalServicesSection__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Drafts_PaymentDetailsSection__ = __webpack_require__(1203);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'SecretaryDraftDetails',
  components: {
    PageHeading: __WEBPACK_IMPORTED_MODULE_6__components_PageHeading__["a" /* default */],
    DraftDetailsSection: __WEBPACK_IMPORTED_MODULE_10__components_Drafts_DraftDetailsSection__["a" /* default */],
    DraftRulesSection: __WEBPACK_IMPORTED_MODULE_11__components_Drafts_DraftRulesSection__["a" /* default */],
    MedicalServicesSection: __WEBPACK_IMPORTED_MODULE_12__components_Drafts_MedicalServicesSection__["a" /* default */],
    PaymentDetailsSection: __WEBPACK_IMPORTED_MODULE_13__components_Drafts_PaymentDetailsSection__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_7__components_AppButton__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_8__components_DesktopActionBar__["a" /* default */],
    MobileSubmitButton: __WEBPACK_IMPORTED_MODULE_9__components_MobileSubmitButton__["a" /* default */]
  },
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var form = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])(Object(__WEBPACK_IMPORTED_MODULE_4__composables_drafts_useDraftForm__["b" /* defaultDraftForm */])());

    var _useAvailableDrafts = Object(__WEBPACK_IMPORTED_MODULE_2__composables_drafts_useAvailableDrafts__["a" /* default */])(),
        draftOptions = _useAvailableDrafts.options,
        loadingDrafts = _useAvailableDrafts.loading;

    var _useDraftStates = Object(__WEBPACK_IMPORTED_MODULE_3__composables_drafts_useDraftStates__["a" /* default */])(),
        draftStates = _useDraftStates.states,
        loadingStates = _useDraftStates.loading;

    var _useDraftForm = Object(__WEBPACK_IMPORTED_MODULE_4__composables_drafts_useDraftForm__["a" /* default */])(form),
        errors = _useDraftForm.errors,
        submitting = _useDraftForm.submitting,
        submit = _useDraftForm.submit;

    var _useCurrentUser = Object(__WEBPACK_IMPORTED_MODULE_5__composables_useCurrentUser__["a" /* default */])(),
        currentUser = _useCurrentUser.user;

    var isStripeVerified = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var selected = draftOptions.value.find(function (o) {
        return o.id === form.draft_id;
      });
      return selected != null ? !!selected.is_stripe_verified : false;
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(draftStates, function (states) {
      if (states.length > 0 && form.draft_state_id == null) {
        form.draft_state_id = states[0].id;
      }
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(currentUser, function (me) {
      // CAM-1533: working for another committee — the contact is not the logged-in user, leave empty
      if (!me || proxy.$isActingForOtherCommittee) return;

      if (!form.secretary_contact_name) {
        form.secretary_contact_name = "".concat(me.first_name, " ").concat(me.last_name);
      }

      if (!form.secretary_phone_number) {
        form.secretary_phone_number = me.phone != null ? me.phone : me.mobile_phone;
      }
    });

    function updateForm(updated) {
      Object.assign(form, updated);
    }

    function handleSubmit() {
      return _handleSubmit.apply(this, arguments);
    }

    function _handleSubmit() {
      _handleSubmit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var result, successMsg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return submit();

              case 2:
                result = _context.sent;

                if (result) {
                  successMsg = typeof result.message === 'string' ? result.message : 'Draft created successfully';
                  proxy.$router.push({
                    name: 'Event Create',
                    params: {
                      id: String(result.id)
                    }
                  }, function () {
                    proxy.$nextTick(function () {
                      __WEBPACK_IMPORTED_MODULE_1__store_EventBus__["a" /* default */].$emit('show-success', successMsg);
                    });
                  });
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _handleSubmit.apply(this, arguments);
    }

    return {
      form: form,
      updateForm: updateForm,
      draftOptions: draftOptions,
      loadingDrafts: loadingDrafts,
      isStripeVerified: isStripeVerified,
      draftStates: draftStates,
      loadingStates: loadingStates,
      errors: errors,
      submitting: submitting,
      handleSubmit: handleSubmit
    };
  }
}));

/***/ }),

/***/ 1288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryDraftDetails_vue__ = __webpack_require__(1229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dad4deb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryDraftDetails_vue__ = __webpack_require__(1292);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryDraftDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dad4deb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryDraftDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useAvailableDrafts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__ = __webpack_require__(74);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useAvailableDrafts() {
  var options = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function fetch() {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].availableForSetup();

            case 4:
              res = _context.sent;
              options.value = res.data.data;

            case 6:
              _context.prev = 6;
              loading.value = false;
              return _context.finish(6);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 6, 9]]);
    }));
    return _fetch.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(fetch);
  return {
    options: options,
    loading: loading
  };
}

/***/ }),

/***/ 1290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useCurrentUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_users__ = __webpack_require__(1291);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useCurrentUser() {
  var user = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_1__services_api_users__["a" /* default */].me();

          case 3:
            res = _context.sent;
            user.value = res.data.data;
            _context.next = 9;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  })));
  return {
    user: user
  };
}

/***/ }),

/***/ 1291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  me: function me() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/users/me');
  }
});

/***/ }),

/***/ 1292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit($event)}}},[_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('div',{staticClass:"bg-white rounded mb-4 p-3"},[_c('page-heading',[_vm._v("Create Draft")]),_vm._v(" "),_c('draft-details-section',{attrs:{"value":_vm.form,"edit":false,"available-drafts":_vm.draftOptions,"loading-drafts":_vm.loadingDrafts,"states":_vm.draftStates,"loading-states":_vm.loadingStates,"errors":_vm.errors},on:{"input":_vm.updateForm}}),_vm._v(" "),_c('draft-rules-section',{attrs:{"value":_vm.form,"errors":_vm.errors},on:{"input":_vm.updateForm}}),_vm._v(" "),_c('medical-services-section',{attrs:{"value":_vm.form,"errors":_vm.errors},on:{"input":_vm.updateForm}}),_vm._v(" "),_c('payment-details-section',{attrs:{"value":_vm.form,"errors":_vm.errors,"is-stripe-verified":_vm.isStripeVerified},on:{"input":_vm.updateForm}}),_vm._v(" "),_c('mobile-submit-button',{attrs:{"loading":_vm.submitting,"no-bottom":true}},[_vm._v("\n        Create\n      ")])],1)]),_vm._v(" "),_c('desktop-action-bar',[_c('app-button',{staticClass:"px-md-5",attrs:{"type":"submit","loading":_vm.submitting}},[_vm._v("\n      Create\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"fullWidth":true}},[_c('secretary-draft-details',{staticClass:"row mx-0 show active",attrs:{"slot":"tabContent"},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.a524d68dc84f9272474c.js